export enum BulkActionType {
  ConsultantEmail = "ConsultantEmail",
  ConsultantReassignBA = "ConsultantReassignBA",
  ConsultantAssignTags = "ConsultantAssignTags",
  ConsultantSMS = "ConsultantSMS",
  ConsultantAssignCallList = "ConsultantAssignCallList",
  ConsultantDelete = "ConsultantDelete",
  ConsultantExport = "ConsultantExport",
  ConsultantExportSsn = "ConsultantExportSsn",
  ConsultantOrderQualityDocuments = "ConsultantOrderQualityDocuments"
}

export enum BulkActionStatus {
  Done = "Done",
  Error = "Error",
  Pending = "Pending",
  Running = "Running"
}

export enum BulkActionCommunicationSubType {
  Information = "Information",
  JobMailing = "JobMailing",
  Marketing = "Marketing"
}

export type SelectableBulkActionType =
  | BulkActionType.ConsultantEmail
  | BulkActionType.ConsultantSMS
  | BulkActionType.ConsultantAssignTags
  | BulkActionType.ConsultantAssignCallList
  | BulkActionType.ConsultantReassignBA
  | BulkActionType.ConsultantDelete
  | BulkActionType.ConsultantOrderQualityDocuments;

export const BulkActionSubType: Record<
  SelectableBulkActionType,
  any
> = {
  [BulkActionType.ConsultantEmail]: BulkActionCommunicationSubType,
  [BulkActionType.ConsultantReassignBA]: null,
  [BulkActionType.ConsultantAssignTags]: null,
  [BulkActionType.ConsultantAssignCallList]: null,
  [BulkActionType.ConsultantDelete]: null,
  [BulkActionType.ConsultantSMS]: BulkActionCommunicationSubType,
  [BulkActionType.ConsultantOrderQualityDocuments]: null
} as const;

export type BulkActionSubType =
  (typeof BulkActionSubType)[keyof typeof BulkActionSubType];
